export const environment = {
    production : true,
    version    : '1.0.0',
    baseApi    : 'https://desa-api.campustecnologicodelicai.com',
    campusCode : 'C2',
    cookieDomain: 'desa-web.campusjuridicoicade.com'
};
